import { useEffect, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { geoLocationService } from "../services/geolocationService.js";
import { GlobalStore } from "../stores/global";
import URI from "urijs";

export default () => {
  const { availableCountries } = GlobalStore.useState(s => s);
  const location = new URI(useLocation().pathname).segment(0);
  const countryFromUrl = location && location.toUpperCase();

  const getGeoLocationService = useCallback(async () => {
    let fetchedCountryCode = countryFromUrl || localStorage.getItem("country");
    try {
      if (!/prerender/i.test(navigator.userAgent) && !fetchedCountryCode) {
        const { code } = await geoLocationService();
        if (availableCountries.indexOf(code) !== -1) fetchedCountryCode = code;
      }
    } catch (e) {
      console.error(e.toString());
    } finally {
      // Making sure the country code is valid
      if (!fetchedCountryCode || availableCountries.indexOf(fetchedCountryCode) === -1) fetchedCountryCode = "SG";
      GlobalStore.update(s => {
        s.currentCountryCode = fetchedCountryCode;
      });
      localStorage.setItem("country", fetchedCountryCode);
    }
  }, [availableCountries, countryFromUrl]);

  useEffect(() => {
    getGeoLocationService();
  }, [getGeoLocationService]);

  return null;
};
